import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { BsPlus, BsDash } from 'react-icons/bs';
import StyledMobileMainMenuCardUniversal from './MobileMainMenuCardUniversal.styled';
import { buildNavLink } from '../../helpers/nav-link';

const DEFAULT_CLASS_NAMES = { heading: 't-body-medium', item: 't-list-copy' };
const DEFAULT_ICONS = { plus: (p) => <BsPlus {...p} />, minus: (p) => <BsDash {...p} /> };
const DEFAULT_TRAILING_LINK = { to: '/shop', text: 'SHOP ALL', brandTo: '/brands', brandText: 'ALL BRANDS' };

/**
 * One accordion card for every marketplace. The markup is the rebud one
 * (MobileMainMenuCard); the heading/item typography classes, the plus/minus
 * icons, the trailing link and the three brand-specific CSS values come from
 * headerConfig.mobileMenuConfig.card of the selected market config.
 */
const MobileMainMenuCardUniversal = React.memo((props) => {
  const [isOpen, setIsOpen] = useState();
  const toggleElement = (element) => {
    const el = element.currentTarget.nextElementSibling;
    setIsOpen(!isOpen);
    if (!isOpen) {
      el.style.height = el.scrollHeight + 'px';
    } else {
      el.style.height = '0px';
    }
  };

  const {
    heading,
    list = [],
    type,
    toggleMenu,
    classNames = DEFAULT_CLASS_NAMES,
    icons = DEFAULT_ICONS,
    trailingLink = DEFAULT_TRAILING_LINK,
    styling = {},
  } = props;

  const headingClass = classNames.heading || DEFAULT_CLASS_NAMES.heading;
  const itemClass = classNames.item || DEFAULT_CLASS_NAMES.item;
  const Plus = icons.plus || DEFAULT_ICONS.plus;
  const Minus = icons.minus || DEFAULT_ICONS.minus;

  const isBrand = type === 'brand';
  const trailingTo = (isBrand && trailingLink?.brandTo) || trailingLink?.to;
  const trailingText = (isBrand && trailingLink?.brandText) || trailingLink?.text;

  return (
    <StyledMobileMainMenuCardUniversal themeProps={styling}>
      <div className="collapse__element">
        <div data-testid="collapse__header" onClick={(e) => toggleElement(e)} className="collapse__header">
          <h2 className={headingClass}>{heading}</h2>
          <span className="plus-minus_icon">{isOpen ? <Minus /> : <Plus />}</span>
        </div>
        <div className={`collapse__body ${!isOpen ? 'hidden' : ''}`}>
          {list.map((item, i) => (
            <Link
              onClick={toggleMenu}
              className={`collapse__item ${itemClass}`}
              key={i}
              to={buildNavLink(type, item.uri_param)}
            >
              {item.name}
            </Link>
          ))}
          {trailingLink && (
            <Link onClick={toggleMenu} className={`collapse__item ${itemClass}`} to={trailingTo}>
              {trailingText}
            </Link>
          )}
        </div>
      </div>
    </StyledMobileMainMenuCardUniversal>
  );
});

MobileMainMenuCardUniversal.propTypes = {
  heading: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  list: PropTypes.array,
  toggleMenu: PropTypes.func,
  classNames: PropTypes.shape({
    heading: PropTypes.string,
    item: PropTypes.string,
  }),
  icons: PropTypes.shape({
    plus: PropTypes.func,
    minus: PropTypes.func,
  }),
  trailingLink: PropTypes.shape({
    to: PropTypes.string,
    text: PropTypes.string,
    brandTo: PropTypes.string,
    brandText: PropTypes.string,
  }),
  styling: PropTypes.object,
};

export default MobileMainMenuCardUniversal;
